/* tslint:disable */

declare var Object: any;
export interface ERPfixedAssetInterface {
  "id"?: number;
}

export class ERPfixedAsset implements ERPfixedAssetInterface {
  "id": number;
  constructor(data?: ERPfixedAssetInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ERPfixedAsset`.
   */
  public static getModelName() {
    return "ERPfixedAsset";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ERPfixedAsset for dynamic purposes.
  **/
  public static factory(data: ERPfixedAssetInterface): ERPfixedAsset{
    return new ERPfixedAsset(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ERPfixedAsset',
      plural: 'ERPfixedAssets',
      path: 'ERPfixedAssets',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/ERPfixedAsset.ts